import BaseController from './base_controller'

export default class extends BaseController {
  static values = {
    series: Array,
    categories: Array,
    showLegend: Boolean,
    groupedBarsPadding: Number,
    barSize: Number,
    chartMarginTop: Number,
    chartMarginBottom: Number,
    chartMarginLeft: Number,
    isStacked: Boolean,
    showLabels: Boolean,
    title: String,
    titleOptions: Object,
    legendOptions: Object,
    chartOptions: Object
  }

  doConnect() {
    this.initializeVals()
    super.doConnect()
  }

  initializeVals() {
    this.showLegendValue ||= false
    this.groupedBarsPaddingValue ||= 20
    this.barSizeValue ||= 13
    this.isStackedValue ||= false
    this.titleOptionsValue ||= {}
    this.legendOptionsValue ||= {
      y: -30,
      x: -2
    }
    this.chartOptionsValue ||= {}

    this.chartMarginTopValue ||= this.titleValue ? 100 : 60
    this.chartMarginBottomValue ||= 50
    this.chartMarginLeftValue ||= 100

    if (!this.hasShowLabelsValue) {
      this.showLabelsValue = true
    }

    if (!this.titleValue) {
      this.titleValue = undefined
    }
  }

  calcChartHeight({ seriesAmount, categoriesAmount, groupedBarsPadding, barSize, chartMarginTop, chartMarginBottom, titleSize }) {
    return (categoriesAmount * groupedBarsPadding) +
      (categoriesAmount * seriesAmount * (barSize + 1)) +
      chartMarginTop + chartMarginBottom + titleSize
  }

  get chartOptions() {
    return {
      chart: {
        type: 'bar',
        marginTop: this.chartMarginTopValue,
        marginBottom: this.chartMarginBottomValue,
        marginLeft: this.chartMarginLeftValue,
        height: this.calcChartHeight({
          seriesAmount: this.isStackedValue ? 1 : this.seriesValue.length,
          categoriesAmount: this.categoriesValue.length,
          groupedBarsPadding: this.groupedBarsPaddingValue,
          barSize: this.barSizeValue,
          chartMarginTop: this.chartMarginTopValue,
          chartMarginBottom: this.chartMarginBottomValue,
          titleSize: this.titleValue ? 18 : 0
        }),
        ...this.chartOptionsValue
      },

      title: {
        text: this.titleValue,
        ...this.titleOptionsValue
      },

      xAxis: {
        categories: this.categoriesValue
      },

      legend: {
        enabled: this.showLegendValue,
        ...this.legendOptionsValue
      },

      stackLabels: {
        enabled: this.isStackedValue
      },

      plotOptions: {
        series: {
          groupedBarsPadding: this.groupedBarsPaddingValue
        },
        bar: {
          stacking: (this.isStackedValue ? 'normal' : undefined),
          animation: false,
          dataLabels: {
            style: { color: '#434343' },
            enabled: this.showLabelsValue,
            crop: false,
            overflow: 'none',
            formatter: function() {
              if (this.y !== 0) {
                return this.y
              }
            }
          }
        }
      },

      series: this.seriesWithParams(
        this.seriesValue,
        this.seriesDefaultOptions
      )
    }
  }

  get seriesDefaultOptions() {
    return {
      pointWidth: this.barSizeValue,
      ...this.disableLegendEventsSeriesOptions
    }
  }

  get disableLegendEventsSeriesOptions() {
    return {
      states: {
        inactive: {
          opacity: 1
        }
      },
      events: {
        legendItemClick: function() {
          return false
        }
      }
    }
  }

  isChartDisplayable() {
    return this.hasSeriesValue && this.hasCategoriesValue
  }
}
